import { render, staticRenderFns } from "./CustomerOrderDetail.vue?vue&type=template&id=5f50ddba&scoped=true"
import script from "./CustomerOrderDetail.vue?vue&type=script&lang=js"
export * from "./CustomerOrderDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f50ddba",
  null
  
)

export default component.exports